// Route Code Edited 6/2/26
/**
 * Restores the cart subtotal (and its dot separator) to Route's cloned
 * checkout button. Route clones the original button but strips its child
 * spans, so this script re-injects a <span class="cart-drawer__button-price">
 * inside .route-button-text and keeps it in sync when the cart updates.
 *
 * Installation:
 * Add at the bottom of layout/theme.liquid (before </body>):
 *
 * <!-- Route Code -->
 * <script src="{{ 'route-cloned-button-price.js' | asset_url }}" defer></script>
 * <!-- End Route Code -->
 */
(function routeClonedButtonPrice() {
  const CLONED_BTN_SELECTOR = '[data-route-cloned-button]';
  const PRICE_SPAN_CLASS = 'cart-drawer__button-price';

  var style = document.createElement('style');
  style.textContent = '.route-button-text { column-gap: 1.125rem !important; }';
  document.head.appendChild(style);

  function getOriginalPriceSpan(clonedBtn) {
    if (clonedBtn._routeOriginalPriceSpan) return clonedBtn._routeOriginalPriceSpan;
    var group = clonedBtn.closest('.button-group');
    if (!group) return null;
    var originalBtn = group.querySelector('button[name="checkout"]:not([data-route-cloned-button])');
    if (!originalBtn) return null;
    var span = originalBtn.querySelector('.' + PRICE_SPAN_CLASS);
    if (span) clonedBtn._routeOriginalPriceSpan = span;
    return span;
  }

  function syncPrice(clonedBtn) {
    var originalPrice = getOriginalPriceSpan(clonedBtn);
    if (!originalPrice) return;

    var routeTextSpan = clonedBtn.querySelector('.route-button-text');
    if (!routeTextSpan) return;

    var injected = routeTextSpan.querySelector('.' + PRICE_SPAN_CLASS);
    if (!injected) {
      injected = document.createElement('span');
      injected.className = PRICE_SPAN_CLASS;
      routeTextSpan.appendChild(injected);
    }

    if (injected.textContent !== originalPrice.textContent) {
      injected.textContent = originalPrice.textContent;
    }
  }

  function watchOriginalPrice(clonedBtn) {
    var originalPrice = getOriginalPriceSpan(clonedBtn);
    if (!originalPrice) return;

    var priceObserver = new MutationObserver(function () {
      syncPrice(clonedBtn);
    });
    priceObserver.observe(originalPrice, { characterData: true, childList: true, subtree: true });
  }

  function interceptInnerHTML(clonedBtn) {
    var nativeDescriptor = Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML');
    Object.defineProperty(clonedBtn, 'innerHTML', {
      set: function (value) {
        nativeDescriptor.set.call(this, value);
        syncPrice(clonedBtn);
      },
      get: function () {
        return nativeDescriptor.get.call(this);
      },
      configurable: true,
      enumerable: true,
    });
  }

  function watchClonedButton(clonedBtn) {
    var btnObserver = new MutationObserver(function () {
      var routeTextSpan = clonedBtn.querySelector('.route-button-text');
      if (routeTextSpan && !routeTextSpan.querySelector('.' + PRICE_SPAN_CLASS)) {
        syncPrice(clonedBtn);
      }
    });
    btnObserver.observe(clonedBtn, { childList: true, subtree: true });
  }

  function processClonedButton(btn) {
    if (btn._routePriceInjected) return;
    btn._routePriceInjected = true;
    syncPrice(btn);
    watchOriginalPrice(btn);
    interceptInnerHTML(btn);
    watchClonedButton(btn);
  }

  var domObserver = new MutationObserver(function () {
    document.querySelectorAll(CLONED_BTN_SELECTOR).forEach(processClonedButton);
  });

  domObserver.observe(document.body, { childList: true, subtree: true });
  document.querySelectorAll(CLONED_BTN_SELECTOR).forEach(processClonedButton);

  window.addEventListener('pagehide', function () { domObserver.disconnect(); });

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    domObserver.observe(document.body, { childList: true, subtree: true });
    document.querySelectorAll(CLONED_BTN_SELECTOR).forEach(function (btn) {
      syncPrice(btn);
      processClonedButton(btn);
    });
  });
})();
